import { ProcessedMessage } from './useProcessMessage'
import { DriveItem } from '@microsoft/microsoft-graph-types'
import { useQueue } from '../useQueue'
import { QueueStatus } from '../queue/queueTypes'

/**
 * Messages originating from the Inboxer in order to update a EmailFilingToast.
 */
export type EmailFiledNotificationData = {
    messageId: string // The original service bus message ID.
    driveItem: DriveItem
}

export type EmailFiledNotification = ProcessedMessage<EmailFiledNotificationData>

export default function useProcessEmailFiledNotification() {
    const queue = useQueue()

    return (notification: EmailFiledNotification) => {
        queue.transition(notification.data.messageId, QueueStatus.Finished)
    }
}
